<canvas
  #canvas
  class="color-palette rounded-lg"
  width= "352"
  height= "250"
  (mousedown)="onMouseDown($event)"
  (mousemove)="onMouseMove($event)"
>
</canvas>
